import { useEffect, useState } from "react";
import { useHistory, NavLink } from "react-router-dom";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import "./CourseForm.scss";

//context
// import CollegeContext from "../../context/colleges/collegeContext";
// import AlertContext from "../../context/alert/alertContext";
// import CourseContext from "../../context/courses/courseContext";
//context

import Input from "./Inputs/Input";
import CustomSingleSelect from "./Inputs/CustomSingleSelect";
import { collegeSelection } from "../../helper/collegesSelection";
import { useDispatch, useSelector } from "react-redux";
import { getColleges } from "../../actions/college";
import CustomSelect from "./Inputs/CustomSelect";
import { campusSelect } from "../../helper/campusSelection";
import { createCourse } from "../../actions/course";
import LoaderDots from "../generalComponents/LoaderDots";
import AlertPopUp from "../generalComponents/AlertPopUp";

const CourseForm = () => {
  const [formValues] = useState(null);
  const [campusOptions, setCampusOptions] = useState([]);

  const dispatch = useDispatch();

  const history = useHistory();

  const { colleges } = useSelector((state) => state.colleges);
  const { campus } = useSelector((state) => state.courses);
  const { loading } = useSelector((state) => state.ui);
  const { msgAlert } = useSelector((state) => state.alert);

  useEffect(() => {
    dispatch(getColleges());
    //eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    const locationFromCampus = campusSelect(colleges, campus);
    setCampusOptions(locationFromCampus);
    //eslint-disable-next-line
  }, [campus]);

  const options = collegeSelection(colleges);

  const initialValues = {
    college: "",
    name: "",
    duration: "",
    campus: [],
    material: "",
    tuitionfee: "",
    applicationfee: "",
  };

  const courseSchema = Yup.object().shape({
    college: Yup.object().required("Select a college"),
    name: Yup.string().required("Name is required"),
    duration: Yup.number()
      .required("Duration is required")
      .min(1, "Invalid Number"),
    campus: Yup.array().min(1, "Select at least one option"),
    material: Yup.number()
      .required("Material is required")
      .min(0, "Invalid Number"),
    tuitionfee: Yup.number()
      .required("Tuition is required")
      .min(0, "Invalid Number"),
    applicationfee: Yup.number()
      .required("Application Fee is required")
      .min(0, "Invalid Number"),
  });

  const handleFromikSubmit = (values, actions) => {
    const { value, label } = values.college;
    const obj = { _id: value, name: label };
    values.college = obj;
    values.collegeBelongId = obj._id;

    dispatch(createCourse(values));

    actions.resetForm();

    setTimeout(() => {
      history.push("/creator/courses");
    }, 1000);
  };

  return (
    <div className="app__courseForm">
      <div>
        <div className="new-course-form__heading">
          <div className="course-form__heading--title">
            <h1 className="title-22-bold-grey">Add a new Course</h1>
            <NavLink to={`/creator/courses`}>
              <button className="btn-primary">Go Back</button>
            </NavLink>
          </div>
          <p className="text-20-grey paragraph">
            This form allows you to create a new Course.
          </p>
        </div>

        <Formik
          initialValues={formValues || initialValues}
          validationSchema={courseSchema}
          onSubmit={handleFromikSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, errors }) => {
            const valueCollege = values.college.value;
            const valueCampus = values.campus;

            return (
              <div className="form-course__wrapper">
                <div className="form-container">
                  <Form>
                    <div className="section-college-select">
                      <label htmlFor="college" className="title-gray-black-18">
                        College:
                      </label>
                      <CustomSingleSelect
                        options={options}
                        value={valueCollege}
                        onChange={(value) => setFieldValue("college", value)}
                        className={`custom-single-select`}
                      />
                      <div className="error-message-form">
                        <ErrorMessage name="college" />
                      </div>
                    </div>
                    <Input name="name" label="Name:" />
                    <Input
                      name="duration"
                      type="number"
                      label="Duration (Weeks):"
                    />

                    <div className="section-campus-select">
                      <label htmlFor="campus" className="title-gray-black-18">
                        CAMPUS:
                      </label>

                      <CustomSelect
                        options={campusOptions}
                        value={valueCampus}
                        onChange={(value) => setFieldValue("campus", value)}
                      />
                      <div className="error-message-form">
                        <ErrorMessage name="campus" />
                      </div>
                    </div>
                    <Input
                      name="tuitionfee"
                      type="number"
                      label="Tuition Fee (AUD):"
                    />

                    <Input
                      name="material"
                      type="number"
                      label="Material (AUD):"
                    />

                    <Input
                      name="applicationfee"
                      type="number"
                      label="Application Fee (AUD):"
                    />

                    <div>
                      {loading ? (
                        <LoaderDots />
                      ) : (
                        <button className="btn-save" type="submit">
                          Add Course
                        </button>
                      )}
                    </div>
                  </Form>
                </div>

                <div className="alert-container">
                  {msgAlert && (
                    <AlertPopUp msg={`${msgAlert.msg}`} type={msgAlert.type} />
                  )}
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default CourseForm;
